import { CircularProgress } from '@ltvco/refresh-lib/theme';
import React from 'react';

import { LoadingStateContainer } from '../components';

export interface InlineLoadingProps {
  size?: number;
}

export const InlineLoading: React.FC<InlineLoadingProps> = ({ size = 32 }) => (
  <LoadingStateContainer>
    <CircularProgress size={size} />
  </LoadingStateContainer>
);
